import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RowBody } from "../../../components/RowValue/RowBody";
import {
  BemessungssituationState,
  selectBemessungssituation,
  setBemessungssituation,
} from "../../../store/slices/innereSlice";

function Bemessungssituation({ readOnly = true }) {
  const { t } = useTranslation("translation");

  const dispatch = useDispatch();
  const bemessungssituation = useSelector(selectBemessungssituation);

  function renderBemessungssituation(val) {
    switch (val) {
      case BemessungssituationState.DAUERHAFT:
        return t("inner.permanent");
      case BemessungssituationState.TEMPORÄR:
        return t("inner.temporary");
      default:
        return "";
    }
  }

  function renderInput() {
    if (readOnly) {
      return <span className="input">{renderBemessungssituation(bemessungssituation)}</span>;
    }

    return (
      <select
        className="change-input"
        onChange={(e) => {
          dispatch(setBemessungssituation(e.target.value));
        }}
        name="bemessungssituation"
        id="bemessungssituation"
        value={bemessungssituation}
      >
        <option key={1} value={BemessungssituationState.DAUERHAFT}>
          {t("inner.permanent")}
        </option>
        <option key={2} value={BemessungssituationState.TEMPORÄR}>
          {t("inner.temporary")}
        </option>
      </select>
    );
  }

  return (
    <RowBody titleValue={<p>{t("inner.dimensioningSituation")}</p>} inputValue={renderInput()} />
  );
}

export default Bemessungssituation;
